import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../../components/Modal';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import attachValidation from '../../utils/form-validation';
import { getDataFromForm } from '../../utils/misc';

class EditSchools {
	constructor() {
		this.disabilityStatus = undefined;
		this.schoolsList = [];
		this._container = SelectorEngine.findOne('.js-edit-coach-details-schools');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-schools-form', this._container);

		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-schools-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-schools-back', this._container);
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-schools-continue', this._container);
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-schools-exit', this._container);
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._hideSectionWrapper = SelectorEngine.findOne('.lta-coach-details__edit-schools-disability', this._container);

		this._form.addEventListener('change', () => {
			this._openHiddenSection();
		});

		this.isDisability = SelectorEngine.findOne('.lta-disability-status', this._container);
		this.isDisabilityStatus = SelectorEngine.find('input[name="coachSchools"]', this.isDisability);
		this.disabilityCriteria = SelectorEngine.findOne('.lta-coach-details__edit-schools-disability', this._container);
		this.disabilityList = SelectorEngine.find('input[type="checkbox"]', this.disabilityCriteria);

		for (const status of this.isDisabilityStatus) {
			if (status.checked) {
				this.disabilityStatus = status.value;
			}
			status.addEventListener('change', (event) => {
				this.disabilityStatus = event.target.value;
				this._openHiddenSection();
			});
		}
		this._openHiddenSection();
		for (const list of this.disabilityList) {
			if (list.checked) {
				this.schoolsList.push(list.value);
			}
			EventHandler.on(list, 'change', (event) => {
				this.handleCheckboxClick(event);
			});
		}

		this._validationErrorText = SelectorEngine.findOne('.lta-text-input--error', this.disabilityCriteria);

		this._errorContainer = SelectorEngine.findOne('.lta-edit-schools-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});


		this.fv = attachValidation(this._form, {
			coachSchools: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			}
		});
		this.fv.on('core.form.valid', () => {
			this.submitEnquiry(this._form);
		});
	}

	_openHiddenSection() {
		if (this.disabilityStatus === 'true') {
			this.disabilityCriteria.classList.remove('u-hidden');
		} else {
			this.disabilityCriteria.classList.add('u-hidden');
			this.disabilityList.map((value) => (value.checked = false));
			this.schoolsList = [];
		}
	}

	handleCheckboxClick(event) {
		this._validationErrorText.textContent = '';
		this.disabilityCriteria.classList.remove('validation-error')
		if (event.target.checked) {
			this.schoolsList.push(event.target.value);
		} else {
			this.schoolsList = this.schoolsList.filter((value) => value !== event.target.value);
		}
	}

	async submitEnquiry(form) {
		const dataObject = getDataFromForm(form);
		if (dataObject.coachSchools === 'false') {
			this.schoolsList = [];
		} else {
			if (this.schoolsList.length === 0) {
				this._validationErrorText.textContent = 'Please select an option';
				this.disabilityCriteria.classList.add('validation-error')
				return;
			}
			stopLoadingAnimation();
		}

		const payload = {
			updateCoachDetailsRequest: {
				mySchools: {
					schoolCoachFlag: dataObject.coachSchools,
					schoolTypes: this.schoolsList
				}
			}
		};

		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, payload);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			startLoadingAnimation();
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditSchools = new EditSchools();

export default globalEditSchools;
